const tim = {
    state: {
        danmuData: []
    },
    mutations: {
        SET_DAN_MU_DATA: (state, account) => { //来自客户端
            let arr=account[0]._elements;
            let nick=account[0].nick;
            
            let arr1=[];
            arr.forEach(item => {
                if(item.type=='TIMTextElem'){
                    let obj={};
                    obj.name=nick;
                    obj.mess=item.content.text;
                    arr1.push(obj)
                }else if(item.type=='TIMCustomElem'){
                    let o=item.content.data;
                    o=JSON.parse(o);
                    if(o.data.cmd==1){
                        let obj={};
                        // 自定义文本消息
                        obj.name=nick;
                        obj.mess=o.data.msg;
                        arr1.push(obj)
                    }
                    
                }
                if(arr1.length){
                    state.danmuData=[...state.danmuData,...arr1];
                }
            });
            
        },
        SET_DAN_MU_DATA_PC:(state, account)=>{
            let obj={};
            let info=localStorage.getItem('info');
            info=info?JSON.parse(info):{userInfo:{name:'无'}}
            obj.name=info.userInfo.name;
            obj.mess=account;
            state.danmuData.push(obj);
        }
    }
}
export default tim